import React, {Fragment, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Col} from "react-bootstrap";

import {service as StreamBankAuthService} from "../../../Services/StreamBankAuthService";


import {ForgotPasswordForm} from "./ForgotPasswordForm";
import {SET_LOGIN_ERROR} from "../../../Redux/Actions";
import {resetPassword} from "../../../Redux/Thunks/loginThunks";
import {DocumentUtils} from "../../../Utils";
import {useChangePage} from "../../../Hooks/NavigationHooks";

export const ForgotPasswordComponent = props => {
    const dispatch = useDispatch();
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const changePage = useChangePage();

    // ensure any previous session is logged out
    useEffect(() => {
        StreamBankAuthService.Logout();
    }, []);

    const submit = async () => {
        const key = DocumentUtils.GetQueryStringParameter("token");
        if(password === password2) {
            if(await dispatch(resetPassword(key, password))) {
                changePage("/logout?message=Password changed successfully. Please log in again.");
            }
        } else {
            dispatch({type: SET_LOGIN_ERROR, field: 'reset', errorMessage: "Passwords don't match."});
        }
    };

    return <Fragment>
        <Col xs={12} md={3} />
        <Col xs={12} md={6}>
            <ForgotPasswordForm
                Password={password}
                Password2={password2}
                UpdatePassword={setPassword}
                UpdatePassword2={setPassword2}
                Submit={submit}
            />
        </Col>
    </Fragment>;
};

